import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials:', {
    url: supabaseUrl ? 'Present' : 'Missing',
    key: supabaseAnonKey ? 'Present' : 'Missing'
  });
}

// Initialize Supabase client with error handling
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    },
    global: {
      headers: {
        'x-application-name': 'parakh-services'
      }
    }
  }
);

// Add error handling wrapper
const handleSupabaseError = (error: any) => {
  console.error('Supabase operation failed:', error);
  throw new Error(error.message || 'Database operation failed');
};

// Wrapped query builder with error handling
export const safeQuery = async <T>(
  query: Promise<{ data: T | null; error: any }>
): Promise<T> => {
  try {
    const { data, error } = await query;
    if (error) throw error;
    if (!data) throw new Error('No data returned');
    return data;
  } catch (error) {
    handleSupabaseError(error);
    throw error; // Re-throw to be handled by the component
  }
};